import { useOutletContext } from "react-router-dom";

import ProductionRequestsView from "../views/ProductionRequests/ProductionRequestsView";

export default function ProductionRequests() {
	const { mappedProductionRequests, loading } = useOutletContext();

	return <ProductionRequestsView mappedProductionRequests={mappedProductionRequests} loading={loading} />;
}
